/**
 * The optional cue at each change of breath, so a student can follow with
 * their eyes closed: one soft, low tone, and a short buzz on phones that
 * support it. Off unless the student turns it on. Fails silently - no sound
 * is an acceptable outcome.
 */
export function playBreathCue(rising: boolean): void {
  try {
    navigator.vibrate?.(20);
    const AudioCtx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const start = ctx.currentTime;
    osc.type = 'sine';
    // A little higher for breathing in, lower for breathing out.
    osc.frequency.value = rising ? 392 : 294;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.08, start + 0.08);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.9);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + 1);
    window.setTimeout(() => void ctx.close(), 1500);
  } catch {
    // No sound or vibration is fine.
  }
}
